/* =============================================================================
 * FOZOCO • Promo no carrinho (2026-11-01)
 * -----------------------------------------------------------------------------
 * Barra da promo ativa no carrinho: progresso até cada faixa ("Adicione mais 3
 * óculos e pague só 2"), no visual da barra de recompensas nativa do Section
 * Store. O desconto aplicado o próprio app já mostra no rodapé. Substitui o
 * antigo fozoco-cart-tiers.js (Monte seu kit).
 *
 * Config (snippets/fozoco-cart-promo.liquid): as promos que o app Campanhas
 * publica no metafield fozoco.carrinho_promo (#fz-cart-promos) ou, se ligada, a
 * promo manual de Configurações do tema > Promo no carrinho
 * (window.FOZOCO_CART_PROMO), que tem prioridade. Este arquivo não decide
 * desconto nenhum: as faixas são só texto.
 *
 * Onde desenha:
 *   - drawer do Section Store (<section-store--cart-block>, shadow root aberto):
 *     logo abaixo do timer "ENVIO NACIONAL" (ou da .cart-reward-bar nativa,
 *     vazia, se o timer sumir); um MutationObserver recoloca a barra quando o app re-renderiza;
 *   - qualquer [data-fz-promo-slot] do documento (página /cart), com o CSS
 *     .cart-reward* copiado do shadow root do app.
 * Atualiza em toda chamada /cart/* (fetch embrulhado) e em theme:cart:change.
 * Conta só os tipos de produto da config; a lente do grau (_fozoco_bundle_role
 * = lente) nunca conta, mesmo que o tipo bata.
 * ========================================================================== */
(function () {
  "use strict";
  // Promo do momento: a manual do tema (se ligada) ou a do Campanhas cuja janela
  // contém agora, só com as faixas que já começaram.
  function fromCampanhas() {
    var el = document.getElementById("fz-cart-promos"), dados;
    try { dados = JSON.parse(el.textContent); } catch (e) { return null; }
    if (!dados || dados.v !== 1 || !dados.promos) return null;
    var now = Date.now();
    for (var i = 0; i < dados.promos.length; i++) {
      var p = dados.promos[i];
      if (now < Date.parse(p.inicio) || now > Date.parse(p.fim) + 59999) continue;
      var faixas = (p.faixas || []).filter(function (f) { return !f.desde || Date.parse(f.desde) <= now; });
      if (!faixas.length) continue;
      return { name: p.nome, start: p.inicio, end: p.fim, tiers: faixas, done: faixas[faixas.length - 1].done || "" };
    }
    return null;
  }
  var CFG = window.FOZOCO_CART_PROMO || fromCampanhas();
  if (!CFG || window.__FOZOCO_CART_PROMO__) return;
  CFG.types = window.FOZOCO_CART_TYPES || [];
  CFG.designMode = !!(window.FOZOCO_CART_PROMO && window.FOZOCO_CART_DESIGN_MODE);
  window.__FOZOCO_CART_PROMO__ = true;

  var HOST_TAG = "section-store--cart-block";
  var BAR_CLASS = "fz-promo";
  var STYLE_ID = "fz-promo-style";
  var TIERS = (CFG.tiers || []).filter(function (t) { return t && t.qty > 0; })
    .sort(function (a, b) { return a.qty - b.qty; });
  if (!TIERS.length) return;
  var MAX = TIERS[TIERS.length - 1].qty;

  // Visual = a barra de recompensas NATIVA do Section Store (.cart-reward*): a
  // marcação abaixo é a mesma do app, então o CSS do próprio app desenha a barra.
  // Aqui só as cores (as do drawer: #185B62 é o verde do timer e dos botões).
  var VARS = "--reward-bar-fill-color:#185B62;--reward-bar-bg-color:#E5E7EB;--reward-text-color:#121212;" +
    "--reward-tier-color:#9CA3AF;--reward-tier-unlocked-color:#121212;--reward-fill-start:0%;--reward-fill-t:1;" +
    "--reward-fill-next-inset:0px;--reward-fill-end-inset:0px";
  var CSS = "." + BAR_CLASS + "[hidden]{display:none!important}" +
    "." + BAR_CLASS + " .cart-reward{" + VARS + "}" +
    "." + BAR_CLASS + " .cart-reward-text{text-wrap:balance}" +
    "." + BAR_CLASS + " .cart-reward-milestone-title{white-space:nowrap;-webkit-line-clamp:unset;line-clamp:unset}";

  // ícones de 24px no mesmo traço dos do app: etiqueta antes, check depois
  var ICONS = '<svg class="cart-reward-milestone-icon--before-reached" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12.2V4.5A1.5 1.5 0 0 1 4.5 3h7.7a1.5 1.5 0 0 1 1.06.44l7.3 7.3a1.5 1.5 0 0 1 0 2.12l-7.7 7.7a1.5 1.5 0 0 1-2.12 0l-7.3-7.3A1.5 1.5 0 0 1 3 12.2zM7.75 9.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5z"/></svg>' +
    '<svg class="cart-reward-milestone-icon--reached" viewBox="0 0 24 24" aria-hidden="true"><path d="M9.55 17.6 4.4 12.45l1.6-1.6 3.55 3.55 8.45-8.45 1.6 1.6z"/></svg>';

  // "2026-11-01 00:00" em horário de Brasília (UTC-3, sem horário de verão)
  function parseBR(s) {
    var m = /^\s*(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?/.exec(s || "");
    if (!m) return null;
    return Date.UTC(+m[1], +m[2] - 1, +m[3], (+m[4] || 0) + 3, +m[5] || 0);
  }
  function inWindow() {
    if (CFG.designMode) return true;
    var now = Date.now(), a = parseBR(CFG.start), b = parseBR(CFG.end);
    if (a && now < a) return false;
    if (b && now > b + 59999) return false;
    return true;
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; });
  }
  function oculos(n) { return n === 1 ? "1 óculos" : n + " óculos"; }

  // Só letras e números: a faixa "Leve 4, pague 2" casa com o desconto
  // "Black November · Leve 4 Pague 2" apesar da vírgula.
  function norm(s) { return String(s || "").toLowerCase().replace(/[^0-9a-zà-ÿ]+/g, " ").trim(); }

  // Faixa batida = quantidade alcançada OU desconto com o nome da faixa já aplicado
  // pela Shopify (rede de segurança se um tipo de produto faltar na config).
  function hit(t) {
    if (state.count >= t.qty) return true;
    var l = norm(t.label);
    return !!l && state.titles.some(function (x) { return norm(x).indexOf(l) > -1; });
  }

  function message(n) {
    var reached = null, next = null;
    for (var i = 0; i < TIERS.length; i++) {
      if (hit(TIERS[i])) reached = TIERS[i]; else { next = TIERS[i]; break; }
    }
    if (!next) {
      return "<strong>" + esc(reached.label) + " garantido!</strong>" + (CFG.done ? " " + esc(CFG.done) : "");
    }
    var falta = next.qty - n;
    var ask = (reached || n > 0 ? "Adicione mais " : "Adicione ") + "<strong>" + oculos(falta) + "</strong> e <strong>" + esc(next.goal || next.label) + "</strong>.";
    return reached ? "<strong>" + esc(reached.label) + " garantido.</strong> " + ask : ask;
  }

  // estado do carrinho, compartilhado entre drawer e página
  var state = null;

  function compute(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) {
      var role = it.properties && it.properties._fozoco_bundle_role;
      if (role === "lente") return;
      if ((CFG.types || []).indexOf(it.product_type) > -1) n += it.quantity;
    });
    var titles = [];
    (cart.cart_level_discount_applications || []).forEach(function (d) { if (d.title) titles.push(d.title); });
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        if (a.discount_application && a.discount_application.title) titles.push(a.discount_application.title);
      });
    });
    return { count: n, items: (cart.items || []).length, titles: titles };
  }

  // nome da faixa embaixo do ponto: uma parte por linha, quebrando na vírgula
  // ("Leve 4, pague 2" -> "Leve 4," / "Pague 2")
  function stacked(label) {
    return String(label || "").split(",").map(function (p) {
      p = p.trim();
      return esc(p.charAt(0).toUpperCase() + p.slice(1));
    }).filter(Boolean).join(",<br>");
  }

  function build(doc) {
    var bar = doc.createElement("div");
    bar.className = "cart-reward-bar " + BAR_CLASS;
    bar.setAttribute("role", "status");
    bar.setAttribute("aria-live", "polite");
    var ms = "";
    TIERS.forEach(function (t) {
      ms += '<div class="cart-reward-milestone" data-q="' + t.qty + '" style="--reward-milestone-position:' + (t.qty / MAX) * 100 + '%">' +
        '<span class="cart-reward-milestone-dot">' + ICONS + "</span>" +
        '<span class="cart-reward-milestone-threshold">' + esc(oculos(t.qty)) + "</span>" +
        '<span class="cart-reward-milestone-title">' + stacked(t.label) + "</span></div>";
    });
    bar.innerHTML = '<div class="cart-reward" data-reward-text-align="center"><p class="cart-reward-text"></p>' +
      '<div class="cart-reward-progress"><div class="cart-reward-track"><span class="cart-reward-fill"></span></div>' +
      '<div class="cart-reward-milestones">' + ms + "</div></div></div>";
    return bar;
  }

  function paint(bar) {
    if (!state) return;
    var show = inWindow() && state.items > 0;
    bar.hidden = !show;
    if (!show) return;
    var n = state.count;
    bar.querySelector(".cart-reward-text").innerHTML = message(n);
    var fillQ = n;
    TIERS.forEach(function (t) { if (hit(t)) fillQ = Math.max(fillQ, t.qty); });
    bar.querySelector(".cart-reward").style.setProperty("--reward-fill-next", Math.min(100, (fillQ / MAX) * 100) + "%");
    var marks = bar.querySelectorAll(".cart-reward-milestone");
    for (var i = 0; i < marks.length; i++) {
      var on = hit(TIERS[i]);
      // animação nativa de "faixa batida" só quando a faixa acabou de ser alcançada
      var was = marks[i].getAttribute("data-on");
      marks[i].classList.toggle("is-tier-complete", on && was === "0");
      marks[i].setAttribute("data-on", on ? "1" : "0");
      marks[i].classList.toggle("is-unlocked", on);
    }
  }

  // Página /cart: o CSS nativo mora no shadow root do drawer; copia as regras
  // .cart-reward* de lá para o documento (o app carrega em todas as páginas).
  function nativeCss() {
    var host = document.querySelector(HOST_TAG), root = host && host.shadowRoot;
    if (!root) return "";
    var out = [];
    Array.prototype.forEach.call(root.querySelectorAll("style"), function (st) {
      try {
        Array.prototype.forEach.call(st.sheet.cssRules, function (r) {
          if (/cart-reward/.test(r.cssText)) out.push(r.cssText);
        });
      } catch (e) {}
    });
    return out.join("\n");
  }

  // ---- drawer do Section Store -------------------------------------------------
  var drawerRoot = null;
  // logo abaixo da faixa "ENVIO NACIONAL | PEDIDO RESERVADO" (timer); sem timer,
  // no lugar da barra de recompensas nativa
  function anchor(root) {
    var t = root.querySelector(".cart-timer-module");
    if (t && !t.hidden) return t;
    return root.querySelector(".cart-reward-bar:not(." + BAR_CLASS + ")");
  }
  function placed(root) {
    var bar = root.querySelector("." + BAR_CLASS), a = anchor(root);
    return bar && a && a.nextElementSibling === bar;
  }
  function paintDrawer() {
    var root = drawerRoot;
    if (!root) return;
    if (!root.getElementById(STYLE_ID)) {
      var st = document.createElement("style");
      st.id = STYLE_ID;
      st.textContent = CSS;
      root.appendChild(st);
    }
    var a = anchor(root);
    var bar = root.querySelector("." + BAR_CLASS);
    if (!a) { if (bar) bar.remove(); return; }
    if (!placed(root)) {
      if (bar) bar.remove();
      bar = build(document);
      a.parentNode.insertBefore(bar, a.nextSibling);
    }
    paint(bar);
  }

  // ---- página /cart e outros slots no documento --------------------------------
  function paintSlots() {
    var slots = document.querySelectorAll("[data-fz-promo-slot]");
    if (!slots.length) return;
    var st = document.getElementById(STYLE_ID);
    if (!st || !st.getAttribute("data-native")) {
      var css = nativeCss();
      if (!st) { st = document.createElement("style"); st.id = STYLE_ID; document.head.appendChild(st); }
      st.textContent = css + "\n" + CSS + "\n[data-fz-promo-slot] .cart-reward{background:transparent;padding-left:0;padding-right:0}";
      if (css) st.setAttribute("data-native", "1");
    }
    for (var i = 0; i < slots.length; i++) {
      var bar = slots[i].querySelector("." + BAR_CLASS);
      if (!bar) { bar = build(document); slots[i].appendChild(bar); }
      paint(bar);
    }
  }

  function paintAll() { paintDrawer(); paintSlots(); }

  var pending = null;
  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      origFetch.call(window, "/cart.js", { credentials: "same-origin", cache: "no-store" })
        .then(function (r) { return r.json(); })
        .then(function (cart) { state = compute(cart); paintAll(); })
        .catch(function () {});
    }, 200);
  }

  // qualquer /cart/add|change|update|clear (app, tema, cart-guard) dispara refresh
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { refresh(); }, function () {});
    return p;
  };
  document.addEventListener("theme:cart:change", refresh);

  refresh();

  var attempts = 0;
  (function attach() {
    var host = document.querySelector(HOST_TAG);
    if (host && host.shadowRoot) {
      drawerRoot = host.shadowRoot;
      paintDrawer();
      var lastSig = "";
      new MutationObserver(function () {
        // recoloca a barra depois que o app re-renderiza; refaz o fetch só quando as linhas mudam
        var sig = Array.prototype.map.call(drawerRoot.querySelectorAll(".cart-line-item"), function (el) { return el.textContent.length; }).join(",");
        if (sig !== lastSig) { lastSig = sig; refresh(); }
        if (anchor(drawerRoot) && !placed(drawerRoot)) paintDrawer();
      }).observe(drawerRoot, { childList: true, subtree: true });
      return;
    }
    if (++attempts > 60) return;
    setTimeout(attach, 500);
  })();
})();
